"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alignment = void 0;
/**
 * enum for setting block alignment, used by setAlignment API
 */
var Alignment;
(function (Alignment) {
    /**
     * Align left
     */
    Alignment[Alignment["Left"] = 0] = "Left";
    /**
     * Align center
     */
    Alignment[Alignment["Center"] = 1] = "Center";
    /**
     * Align right
     */
    Alignment[Alignment["Right"] = 2] = "Right";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
//# sourceMappingURL=Alignment.js.map